import { render } from "./AssessRates.vue?vue&type=template&id=8830caf2&scoped=true"
import script from "./AssessRates.vue?vue&type=script&lang=js"
export * from "./AssessRates.vue?vue&type=script&lang=js"

import "./AssessRates.vue?vue&type=style&index=0&id=8830caf2&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8830caf2"]])

export default __exports__